import { CreateTeamFormSchema, CreateTeamSearchParamSchema } from "@/schemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { FormProvider, useForm } from "react-hook-form";

export const Route = createFileRoute("/dashboard/teams/create")({
	validateSearch: zodSearchValidator(CreateTeamSearchParamSchema),
	component: RouteComponent,
});

function RouteComponent() {
	const isDirectorySearchParams = Route.useSearch({
		select: (s) => s.directory ?? false,
	});
	const formMethod = useForm<CreateTeamFormSchema>({
		mode: "all",
		resolver: zodResolver(CreateTeamFormSchema),
		defaultValues: {
			directory: isDirectorySearchParams,
			user_ids: new Set(),
			name: "",
		},
	});

	return (
		<FormProvider {...formMethod}>
			<Outlet />
		</FormProvider>
	);
}
